import { environment } from '../environments/environment'

export const API_ASSIGNATURE = environment.api.assignature;